













































































































import { Mixins, Component } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../../../base/components/system/selectors/mixins";
import { ObjectUtility } from "../../../../../../../base/utilities";
import { IExternalScriptSpecification } from "../../../../../../domain/editableFormat";
import { IScriptExecuteParameter } from "../../../../../../../documaker/domain/format/objects";
import { ScriptExecuteParameterSelector } from "../selectors";
import { VariableParameterMixin } from "../mixins";

export interface IScriptPathEditDialogParameter {
  scriptPath: string;
  separator: string;
  parameters: IScriptExecuteParameter[];
}

@Component({
  components: {
    OptionDropDownSelector,
    ScriptExecuteParameterSelector,
  }
})
export default class ScriptPathEditDialog extends Mixins(DialogMixin, VariableParameterMixin) {
  scriptPath: string = "";
  separator: string = "";
  parameters: IScriptExecuteParameter[] = [];
  selectableExternalScripts: StandardOption<string>[] = [];
  selectedExternalScript: string = "";
  fixedParameter: string = "";
  selectedParameters: IScriptExecuteParameter[] = [];
  selectedVariableParameters: IScriptExecuteParameter[] = [];
  confirmed: boolean = false;

  get hasSelectableExternalScripts(): boolean {
    return this.selectableExternalScripts.length > 0;
  }

  get hasFixedParameter(): boolean {
    return this.fixedParameter !== "";
  }

  get variableParameters(): IScriptExecuteParameter[] {
    return Object.keys(this.VariableParameterDictionary).map(v => {
      return { isFixed: false, parameter: v, };
    });
  }

  get hasSelectedParameters(): boolean {
    return this.selectedParameters.length > 0;
  }

  get isTopSelectedParameter(): boolean {
    return this.hasSelectedParameters && this.selectedParameters.some(v => v === this.parameters[0]);
  }

  get isBottomSelectedParameter(): boolean {
    return this.hasSelectedParameters && this.selectedParameters.some(v => v === this.parameters[this.parameters.length - 1]);
  }

  get hasSelectedVariableParameters(): boolean {
    return this.selectedVariableParameters.length > 0;
  }

  get previewScriptPath(): string {
    return this.toPreviewScriptFileName() + " " + this.toPreviewSeparator() + this.toPreviewParameter();
  }

  private toPreviewScriptFileName(): string {
    const m = this.scriptPath.match(/^.*\\/);
    return !!m
      ? this.scriptPath.replace(m[0], "")
      : "";
  }

  private toPreviewSeparator(): string {
    return this.separator !== ""
      ? this.separator
      : " ";
  }

  private toPreviewParameter(): string {
    return this.parameters.map(v => this.toParameterString(v)).join(this.toPreviewSeparator());
  }

  private toParameterString(param: IScriptExecuteParameter): string {
    return param.isFixed
      ? param.parameter
      : !!this.VariableParameterDictionary[param.parameter]
        ? "[" + this.VariableParameterDictionary[param.parameter] + "]"
        : "[" + param.parameter + "]";
  }

  async show(parameter: IScriptPathEditDialogParameter, selectableExternalScripts: IExternalScriptSpecification[]): Promise<IScriptPathEditDialogParameter> {
    return this.showModal(async () => {
      const _parameter = ObjectUtility.copyDeeply(parameter) as IScriptPathEditDialogParameter;
      this.scriptPath = _parameter.scriptPath;
      this.separator = _parameter.separator;
      this.parameters = _parameter.parameters;
      this.selectableExternalScripts = this.createSelectableExternalScriptStandardOptions(ObjectUtility.copyDeeply(selectableExternalScripts));
      this.selectedExternalScript = this.selectableExternalScripts.length > 0
        ? this.selectableExternalScripts[0].value
        : "";
      this.fixedParameter = "";
      this.selectedParameters = [];
      this.selectedVariableParameters = [];
      this.confirmed = false;
      await this.waitHidden();
      return this.confirmed
        ? {
          scriptPath: this.scriptPath,
          separator: this.separator,
          parameters: this.parameters,
        }
        : null;
    });
  }

  private createSelectableExternalScriptStandardOptions(selectableExternalScripts: IExternalScriptSpecification[]): StandardOption<string>[] {
    return selectableExternalScripts.map((v) => this.createSelectableExternalScriptStandardOption(v.name, v.path));
  }

  private createSelectableExternalScriptStandardOption(label: string, value: string): StandardOption<string> {
    return { label: label, value: value, description: "", };
  }

  setScriptPath() {
    this.scriptPath = this.selectedExternalScript;
  }

  addFixedParameter() {
    this.parameters = this.parameters.concat({
      isFixed: true,
      parameter: this.fixedParameter,
    });
  }

  addVariableParameters() {
    this.parameters = this.parameters.concat(ObjectUtility.copyDeeply(this.selectedVariableParameters));
  }

  moveParameters(offset: number) {
    const indexes = this.selectedParameters.map(v => this.parameters.indexOf(v)).sort((a, b) => a - b);
    if (offset > 0) {
      indexes.reverse();
    }
    indexes.forEach(i => this.moveParameter(i, offset));
  }

  private moveParameter(index: number, offset: number) {
    const item = this.parameters[index];
    this.parameters.splice(index, 1);
    this.parameters.splice(index + offset, 0, item);
  }

  removeParameters() {
    this.parameters = this.parameters.filter((v) => !this.selectedParameters.some(s => s === v));
  }

  changeParameters(value: IScriptExecuteParameter[]) {
    this.selectedParameters = value;
  }

  changeVariableParameters(value: IScriptExecuteParameter[]) {
    this.selectedVariableParameters = value;
  }

  confirm(): void {
    this.confirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
